import { motion } from "framer-motion";
import { twMerge } from "tailwind-merge";

import Loader from "./Loader";
import WalletSlot from "./WalletSlot";
import { Link } from "react-router-dom";

type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  type?: 'primary' | 'secondary' | 'tertiary';
  size?: 'md' | 'sm';
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  requiresWalletConnection?: boolean;
  to?: string;
  background?: string;
  color?: string;
}

export const Button = (props: ButtonProps) => {
  if (props.requiresWalletConnection) {
    return (
      <WalletSlot>
      {({ connected, connect }) => (
        connected ?
          <_Button {...props} />
          :
          <_Button {...props} onClick={connect} />
        )}
      </WalletSlot>
    )
  }

  return <_Button {...props} />
}

const _Button = (props: ButtonProps) => {
  const { children, className, size = 'md', type = 'primary', onClick: _onClick, disabled, loading, to, background: _background, color: _color } = props;

  const onClick = () => {
    if (disabled || loading) return;
    _onClick?.();
  }

  let backgroundColor;
  switch (type) {
    case 'primary':
      backgroundColor = '#338CF1';
      break;
    case 'secondary':
      backgroundColor = '#757a85';
      break;
    case 'tertiary': 
      backgroundColor = '#C2DCFB';
      break;
    default:
      backgroundColor = '#000';
  }

  let color = '#fff';
  if (type === 'tertiary') {
    color = '#338CF1';
  }

  //
  if (_background) {
    backgroundColor = _background;
  }
  if (_color) {
    color = _color;
  }

  if (disabled) {
    backgroundColor = '#c0c4cc';
    color = '#eff1f5';
  }

  const Comp = to ? motion(Link) : motion.button;

  return (
    <Comp
      to={to}
      target={to?.startsWith('http') ? '_blank' : undefined}
      whileTap={disabled ? {} : { boxShadow: '0px 0px 0px 0 #000', transform: size === 'md' ? 'translate(-1px, 4px)' : 'translate(-1px, 2px)' }}
      transition={{ duration: 0.1 }}
      onClick={onClick}
      disabled={disabled}
      className={twMerge(`flex items-center justify-center w-full relative rounded-[100px] outline-none border border-solid border-black ${size === 'md' ? 'h-[43px]' : 'h-[30px]'}`, className)}
      style={{
        backgroundColor,
        boxShadow: size === 'md' ? '-1px 3px 0px 0 #000' : '-1px 2px 0px 0 #000',
      }}
    >
      <div
        className={`flex justify-center items-center flex-grow gap-2 ${size === 'md' ? 'px-4' : 'px-3'}`}
        style={{
          opacity: disabled ? 0.7 : 1
        }}
      >
        {loading && <Loader stroke={color} size="16px" />}
        <div className="text-[15px] font-bold" style={{ color }}>
          {children}
        </div>
      </div>
    </Comp>
  )
}